import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';
import './PDQCodeHtml'

@customElement('pdq-tutorial-liquid-slicer')
class PDQTutorialLiquidSlicer extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {
    const code = `
<pdq-data-request id="posts-table" url="https://jsonplaceholder.typicode.com/posts" 
  index="id" data-type="json" strategy="useStale"></pdq-data-request>
<pdq-data-request id="users-table" url="https://jsonplaceholder.typicode.com/users"
  index="id" data-type="json" strategy="useStale"></pdq-data-request>


<pdq-liquid>
<template slot="variables">
{
  "users": "users-table"
}
</template>
<script type="text/liquid" >
<cds-select id="users" helper-text="Select a user to filter posts by" label-text="User" placeholder="all users">
  <cds-select-item-group label="Users">
  {% for user in users %}  
    <cds-select-item value="{{user.id}}">{{user.username}} | {{user.name}} </cds-select-item>
  {% endfor %}
  </cds-select-item-group>
</cds-select>
</script>
<script>
this.shadowRoot.querySelector('#users')?.addEventListener('cds-select-selected', async (evt) => {
  // getOrCreateView(viewId, tableId, config) 
  // creates or updates the view 'filtered-posts' (and depended table 'filtered-posts-result-table')
  // using the source table 'posts-table' and the config {filter: [["userId", "==", evt.detail.value]]}
  await window.pdqDataBroker.getOrCreateView('filtered-posts', 'posts-table', {
     filter: [["userId", "==", evt.detail.value]]
  });
  console.log('filtered view to userId == ', evt.detail.value)
}, {signal: this.signal}) // adding signal to the event listener, prevents duplicate event listeners
</script>
</pdq-liquid>
<dpq-dump table="filtered-posts-result-table" show="1"></dpq-dump>
<pdq-perspective-viewer id="posts" table="filtered-posts-result-table"></pdq-perspective-viewer>
`;
    return html`
      <cds-tile>
        <h2>Example: Building a slicer that uses the global data model</h2>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
      </cds-tile>
    `;
  }
}

(window as any).document.addEventListener('selected', (evt: CustomEvent) => {
  console.log('global event listener: selected', evt.detail);
})